export default function trimFormData(formData: FormData) {
  const trimmedFormData = new FormData()

  for (const [key, value] of Array.from(formData.entries())) {
    trimmedFormData.append(key, typeof value === 'string' ? value.trim() : value)
  }

  return trimmedFormData
}
